import React, { ReactElement, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'primereact/button';
import _ from 'lodash';

import { Property } from '../../shared/schema/PropertySchema';
import PropertiesLightbox from './PropertiesLightbox';

import grundrissLogo from './grundriss-symbol.svg';
import s from './Portfolio.module.scss';
import PropertyGroup from './Property/PropertyGroup';

interface PropertiesProps {
  data: Property[];
  handlePropertyClicked: (property: Property) => void;
}

export default function Properties(props: PropertiesProps): ReactElement {
  const { data, handlePropertyClicked } = props;
  const [selectedProperty, selectProperty] = useState(null);
  const closeLightbox = () => {
    selectProperty(null);
  };

  const sortedProperties = [...data];
  const reA = /[^a-zA-Z]/g;
  const reN = /[^0-9]/g;
  sortedProperties.sort((p1, p2) => {
    if (!p1.flatNumber) return 1;
    if (!p2.flatNumber) return -1;

    const aA = p1.flatNumber.replace(reA, '');
    const bA = p2.flatNumber.replace(reA, '');
    if (aA === bA) {
      const aN = parseInt(p1.flatNumber.replace(reN, ''), 10);
      const bN = parseInt(p2.flatNumber.replace(reN, ''), 10);
      // eslint-disable-next-line no-nested-ternary
      return aN === bN ? 0 : aN > bN ? 1 : -1;
    }
    return aA > bA ? 1 : -1;
  });
  const groupedProperties = _.groupBy(sortedProperties, (p) =>
    p.stairs ? p.stairs : 'noStairs'
  );
  const stairs = Object.keys(groupedProperties);
  stairs.sort((key1, key2) => {
    if (key1 === 'noStairs') {
      return -1;
    }
    if (key2 === 'noStairs') {
      return 1;
    }
    return key1.localeCompare(key2, undefined, {
      numeric: true,
      sensitivity: 'base',
    });
  });

  return (
    <>
      <div className={s.subTitle}>Wohneinheiten</div>

      <div className={s.flatWrapper}>
        {stairs.map((key) => {
          const propertyGroup = groupedProperties[key];
          if (key === 'noStairs') {
            return (
              <PropertyGroup
                rows={propertyGroup}
                onSelectProperty={selectProperty}
                handlePropertyClicked={handlePropertyClicked}
              />
            );
          }
          // eslint-disable-next-line no-restricted-globals
          const stairName = isNaN(key as any)
            ? key
            : `Stiege ${parseFloat(key)}`;
          return (
            <>
              <div className={s.stairsWrapper}>
                <strong className={s.stairName}>{stairName}</strong>
              </div>

              <PropertyGroup
                rows={propertyGroup}
                onSelectProperty={selectProperty}
                handlePropertyClicked={handlePropertyClicked}
              />
            </>
          );
        })}
      </div>
      {selectedProperty && (
        <PropertiesLightbox
          property={selectedProperty}
          onClose={() => closeLightbox()}
        />
      )}
    </>
  );
}
